<template>
  <section id="video" class="slideDown">
    <div class="back" @click="back()">{{ $t('admin.video.back') }}</div>

    <div class="container">
      <div class="content">
        <h3 class="title">
          <span v-if="video.id == -1">{{ $t('general.create') }}</span><span v-else>{{ $t('general.edit') }}</span
          ><span>{{ $t('admin.video.video') }}</span>
        </h3>

        <div class="details">
          <!-- <div class="subtitle">Información básica</div> -->
          <v-form ref="form_video" v-model="valid">
            <v-text-field
              v-model="video.url"
              :rules="requiredRules"
              :label="$t('general.url')"
              required
            ></v-text-field>

            <!-- <v-text-field :readonly="true" v-model="video.url" :rules="requiredRules" label="Url" required></v-text-field> -->
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="start_date"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="start_date"
                  :label="$t('general.start_date')"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="start_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false"
                  >{{ $t('general.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="dateSelect(start_date, 'start_date')"
                  >{{ $t('general.accept') }}</v-btn
                >
              </v-date-picker>
            </v-dialog>

            <v-dialog
              ref="dialog2"
              v-model="modal2"
              :return-value.sync="end_date"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="end_date"
                  :label="$t('time.end_date')"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                  id="end_date"
                ></v-text-field>
              </template>
              <v-date-picker v-model="end_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false"
                  >{{ $t('general.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="dateSelect(end_date, 'end_date')"
                  >{{ $t('general.accept') }}</v-btn
                >
              </v-date-picker>
            </v-dialog>
            <v-switch
              v-model="video.status"
              :true-value="1"
              :false-value="0"
              :value="1"
              :label="$t('general.active')"
            ></v-switch>
          </v-form>
        </div>

        <div class="buttons">
          <v-btn color="success" @click="save">{{ $t('general.save') }}</v-btn>
          <v-btn color="cancel" @click="back">{{ $t('general.back') }}</v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";
export default {
  props: {},
  data() {
    return {
      video: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentVideo"])
      ),
      valid: false,
      requiredRules: [v => !!v || i18n.t('general.obligatory_field')],
      modal: false,
      modal2: false,
      start_date: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentVideo"])
      ).start_date,
      end_date: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentVideo"])
      ).end_date,
      url: JSON.parse(
        JSON.stringify(this.$store.getters["sliders/getCurrentVideo"])
      )
        .url.replace(window.location.origin, "")
        .replace(/\/(.*)\//g, "")
    };
  },
  created() {
    var id = this.video.id != -1 ? this.video.id : "add";
    this.$router.push({ name: "videos_edit", params: { id: id } });
  },
  computed: {},
  methods: {
    back() {
      this.$store.commit("sliders/setCurrentVideo", false);
      this.$router.push({ name: "videos" });
    },
    save() {
      if (this.$refs.form_video.validate()) {
        var self = this;
        this.video.start_date = this.start_date ? this.start_date : null;
        this.video.end_date = this.end_date ? this.end_date : null;

        if (this.video.id == -1) {
          this.$store
            .dispatch("sliders/addVideoAdv", this.video)
            .then(function() {
              self.$store.commit("sliders/setCurrentVideo", false);
              self.$router.push({ name: "videos" });
            });
        } else {
          this.$store
            .dispatch("sliders/editVideoAdv", this.video)
            .then(function() {
              self.$store.commit("sliders/setCurrentVideo", false);
              self.$router.push({ name: "videos" });
            });
        }
      }
    },

    dateSelect(date, mode) {
      switch (mode) {
        case "start_date":
          this.$refs.dialog.save(date);
          // this.$refs.end_date.click();
          let clickEvent = new Event("click");
          document.getElementById("end_date").dispatchEvent(clickEvent);
          break;
        case "end_date":
          this.$refs.dialog2.save(date);
          break;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.child {
  border-top: 2px solid var(--main_color);
}
.child2 {
  border-top: 2px solid var(--secondary_color);
}
.separator {
  float: left;
  width: 30px;
  opacity: 0;
}
.selected {
  background-color: var(--secondary_color) !important;
}
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .image {
    width: 40%;
    float: left;
    padding: 0 40px;

    img {
      width: 95%;
    }
  }

  .content {
    width: 100%;
    float: left;
    text-align: left;
    padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }
    .details {
      margin: 20px 0;

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }

    .buttons {
      margin: 35px 0;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid var(--main_color);

          .icon {
            background: url(/img/download.svg) no-repeat center
              var(--main_color);
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}

.searcher {
  padding-top: 0px;
  margin-top: 0px;

  .v-input {
    margin-top: 0px;
    padding-top: 0px;
  }
}
</style>
